import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

const LanguagePicker = () => {
  const { t, i18n } = useTranslation()

  const changeLanguage = () => {
    void (async () => {
      await i18n.changeLanguage(i18n.resolvedLanguage === 'fr' ? 'en' : 'fr')
    })()
  }

  return <Button color="inherit" onClick={changeLanguage}>{t('common.targetLanguage')}</Button>
}

export default LanguagePicker
